export default "__VITE_ASSET__1aa00953__"